import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../../i18n/en';

i18next.addResourceBundle('en', 'dashboard', en);

const DashboardPermissionsListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Dashboard Permissions',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.HOME,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/dashboard/permissions/list',
      component: React.lazy(() => import('./DashboardPermissionsList')),
    },
  ],
};

export default DashboardPermissionsListConfig;
